module.exports = __webpack_public_path__ + "img/Persuasive.7b96ef73.png";